<template>
  <div class="container" id="HomeCard">
    <InfoCard :user="user" />
    <!-- <div class="row">
      <div class="col-4">
        
      </div> -->
    <!-- <div class="col-8 quoteDev">
        <div class="quote shadow-sm p-3 mb-5 bg-body rounded">
          <h2 class="about">
            “A designer knows he has achieved perfection not when there is
            nothing left to add, but when there is nothing left to take away.”
          </h2>
          <h4 class="quoteAuthor">Antoine de Saint-Exupery</h4>
        </div>
      </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import InfoCard from "../components/InfoCard.vue";
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
export default {
  name: "Home",
  props: ["user"],
  components: {
    InfoCard,
    // FontAwesomeIcon,
  },
};
</script>

<style lang="scss">
#HomeCard {
  margin: auto;
  flex-grow: 1;
  margin-top: 1%;
  justify-content: center;
}

.quoteDev {
  margin-top: 5%;
  text-align: center;
}
.quote {
  padding: 5%;
}

.quoteAuthor {
  text-align: end;
  margin-top: 4rem;
}
</style>
